import styled from 'styled-components';

export const PhoneContainer = styled.div`
  .react-tel-input .form-control {
    height: ${({ theme }) => theme.height.h6};
    width: ${({ theme }) => theme.width.full};
  }

  .react-tel-input .phone-input-dropdown .country {
    padding: ${({ theme }) => theme.spacing.sm};
    border-bottom: 1px solid ${({ theme }) => theme.colors.platinum};
  }

  .react-tel-input .country-list {
    width: max-content;
  }

  .react-tel-input .country-list .flag {
    margin-top: ${({ theme }) => theme.spacing.xxs};
  }

  .react-tel-input .country-list .country-name {
    margin-right: ${({ theme }) => theme.spacing.s};
    font-family: 'Source Sans Pro';
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.m};
    line-height: 22px;
    align-items: center;
    color: ${({ theme }) => theme.colors.eerieBlack};
  }

  .react-tel-input .country-list .country .dial-code {
    float: right;
    margin-right: ${({ theme }) => theme.spacing.m};
    font-family: 'Source Sans Pro';
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.m};
    line-height: 22px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.eerieBlack};
  }
`;
